import {requests} from "../../helpers/api.services";
import {JOB_SETTINGS_URL} from "../../helpers/api.routes";

export const JobSettingsService = {
    get: () => requests.get(JOB_SETTINGS_URL),
    update: (payload: FormData) => requests.post(JOB_SETTINGS_URL, payload, true),
    delete: () => requests.delete(JOB_SETTINGS_URL)
}